const invoiceDetail = {
    path: 'invoiceDetail',
    component: resolve => require(['../../../../../pages/admin/merchantInvoice/detail'], resolve),
    meta: {
        requireAuth: true
    }
}

export default invoiceDetail
